import { render, staticRenderFns } from "./transactions-truewallet.vue?vue&type=template&id=2911b5df&"
import script from "./transactions-truewallet.vue?vue&type=script&lang=js&"
export * from "./transactions-truewallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports